import { t as tDefault } from 'i18next';

export const t = (str: string) => tDefault(str);
